// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.27-TSS-2937-mcastro-FEATURE-CSV-Uploads-for-Batch-Spec-Import-Back-End.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
